
import React from 'react';
import { FormattedMessage } from 'react-intl/dist';
import classNames from 'classnames';
import Autocomplete from 'react-autocomplete';


const EnhancedAutocomplete = props => {
    const {
        attributeTypes,
        chosenItems,
        items = [],
        label,
        updateItems,
        updateValue,
        value,
        view
    } = props;

    const handleAttributeSelection = (...args) => {
        const [ , attribute ] = args;
        updateValue(onChange({ target: { value: '' } }));
        updateItems(items => [
            ...items,
            attribute
        ]);
    };

    const renderItem = (item, isHighlighted) => {
        const isAlreadyChosen = !!chosenItems.find(i => i.id === item.id);

        const className = classNames(
            'autocomplete-item',
            { 'highlighted': isHighlighted },
            { 'not-highlighted': !isHighlighted },
            { 'chosen': isAlreadyChosen },
            { 'not-chosen': !isAlreadyChosen }
        );

        return (
            <div key={ item.id } className = { className }>
                { item.name }
            </div>
        );
    };

    const getItem = item => item.name;

    const onChange = e => updateValue(e.target.value);

    const checkIfItemSelectable = item => !chosenItems.find(i => i.id === item.id);

    const renderInput = props => {
        return (
            <input { ...props } className = 'autocomplete-input'/>
        );
    };

    const renderMenu = (...args) => {
        const [ items ] = args;

        return (
            <div className = 'autocomplete-menu'>
                { items }
            </div>
        );
    };

    const shouldItemRender = (...args) => {
        const [ item, value ] = args;
        return item.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
    };

    return (
        <div className = 'margin-bottom-15'>
            <label className = 'search-input-label'>
                <FormattedMessage id = { label } values = {{ attribute: view === attributeTypes.TAGS }}/>
            </label>
            <br/>
            <Autocomplete
                getItemValue = { getItem }
                isItemSelectable = { checkIfItemSelectable }
                items = { items }
                onChange = { onChange }
                onSelect = { handleAttributeSelection }
                renderInput = { renderInput }
                renderItem = { renderItem }
                renderMenu = { renderMenu }
                shouldItemRender = { shouldItemRender }
                value = { value }
                wrapperProps = {{ className: 'autocomplete-wrapper' }}
            />
        </div>
    );
};

export default EnhancedAutocomplete;